import React from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import Button from "../../Button/index.jsx";
import styles from "./style.module.scss";

const Dropdown = (props) => (
  <Downshift
    onChange={props.onChange}
    itemToString={(item) => (item ? item.value : "")}
  >
    {({
      getInputProps,
      getMenuProps,
      getItemProps,
      isOpen,
      toggleMenu,
      clearSelection,
      selectedItem,
    }) => (
      <div>
        <Button {...getInputProps} onClick={toggleMenu} secondary>
          {selectedItem ? selectedItem.value : props.placeholder}
        </Button>
        {props.clearable && selectedItem ? (
          <div className={styles.clear} onClick={clearSelection}>
            Clear selection
          </div>
        ) : null}
        <div className={styles.menu}>
          <ul {...getMenuProps()}>
            {isOpen
              ? props.items.map((item, index) => (
                  <li
                    {...getItemProps({
                      key: item.value,
                      index,
                      item,
                    })}
                  >
                    {item.value}
                  </li>
                ))
              : null}
          </ul>
        </div>
      </div>
    )}
  </Downshift>
);

Dropdown.defaultProps = {
  placeholder: "Select...",
  clearable: false,
};

Dropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  clearable: PropTypes.bool,
};

export default Dropdown;
